import { useState } from 'react'
import TerminalRoute from './TerminalRoute'
import TerminalManager from './TerminalManager'

export default function StandaloneTerminalLayout() {
  const [ready, setReady] = useState(false)

  return (
    <>
      <TerminalRoute onReady={() => setReady(true)} />
      {ready && <TerminalManager />}
    </>
  )
}
